/**
 * <DockBody />
 *
 * @parent anybody
 * @children
 * @stateless
 */
import React, { PropTypes } from 'react';
import { Dock } from 'components/UI';
import { confirmable } from 'react-confirm';
import Loading from 'components/UI/Loading';
import Transition from 'components/UI/Transition';
import { Provider } from 'react-redux'
import _ from 'lodash';
import store from 'root/store';
import locale from './locale';
import HorizontalInfoGrid from 'components/UI/HorizontalInfoGrid';
import VerticalInfoGrid from 'components/UI/VerticalInfoGrid';
import Student from 'mediators/Student';
import StudentHeader from './StudentHeader';
import getStudentCustomFields from 'controllers/student/getStudentCustomFields';
import getSchoolSettings from 'controllers/school/getSchoolSettings'
import PaymentModal from "template/Modals/NewPayment";
import getStudentInfo from 'controllers/student/getStudentInfo';
import getStudentCurrentClass from 'controllers/student/getStudentCurrentClass';
import CourseRecord from './CourseRecord'
import TuitionRecordTable from './Tables/tuitionRecordTable'
import Attendance from 'containers/pages/Teacher/Attendance/Attendance'
import { hotline } from 'vendor/react-redux-hotline';
import Timeline from './Timeline'
import __R, { userCan } from 'containers/__R'
import CreateStudentModal from 'template/Modals/CreateStudent'

import {
	Tab,
	Tabs,
	TabList,
	TabPanel,
} from 'components/UI'

import './style.scss';

const DEFAULT_TAB_INDEX = 0;

const GENDERS = [__('Male', locale), __('Female', locale), __('Others', locale), __('N/A', locale)];

class DockBody extends React.Component {
  static propTypes = {

  }

  constructor(props) {
    super(props);

    this.onClickPayment = this.onClickPayment.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this.fetchStudentInfo = this.fetchStudentInfo.bind(this);
    this.getCustomFields = this.getCustomFields.bind(this);

    let version;
    if (props.studentData) {
      version = props.studentData.version();
    }

    this.state = {
      version,
      student: props.studentData,
      fields: [],
      contactFields: [],
      fetching: true,
      isStudentUpdated: false // to check if the student info or payment is changed in the dock
    }
  }

  getCustomFields(done) {
    const schoolId = localStorage.getItem('schoolId');
    getSchoolSettings(schoolId)
    .then(({ student_fields_setting, contact_custom_fields })=>{

      const fields = [
        ...(student_fields_setting.fields || []),
      ];

      const contactFields = [
        ...(contact_custom_fields.fields || []),
      ];

      this.setState({
        fields,
        contactFields,
      }, ()=>{
        done();
      });
    })
    .catch((err)=>{
      console.error(err);
      done();
    });
  }

  componentWillMount() {
    const {
      version,
    } = this.state;

    const {
      id,
    } = this.props;
    this.getCustomFields(()=>{
      if (version === 'v5') {
        this.setState({
          student: this.props.studentData,
        });
      } else {
        if (!id) {
          throw new Error('The given student version is not v5. So need to load up studentInfo with an id but the id is missing from opts.');
        }

        this.fetchStudentInfo();
      }
    });
  }

  fetchStudentInfo() {
    const {
      id,
    } = this.props;

    this.setState({
      fetching: true,
    });

    getStudentInfo(id)
    .then((student)=>{
			getStudentCurrentClass(id)
			.then((res)=>{
				const classList = res.data.classList;
				const newStudent = new Student({ ...student, classList, })

				this.setState({
					fetching: false,
					student: newStudent,
				});
			});
    })
    .catch((e)=>{});
  }

  onClickEdit() {
    const { student } = this.state;
		CreateStudentModal({mode: 'update', studentData: student})
    .then(({ result, student })=>{

      if (result === 'success') {
        this.setState({isStudentUpdated: true})
        this.fetchStudentInfo(); // we're refetching it, because we don't have updated path for photos
      }
    })
    .catch(()=>{})
  }

  onClickPayment(user_id) {
    const { student } = this.state;
		const { studentState } = this.props.student;

    PaymentModal({ student, user_id, })
    .then(({ success })=>{
      if (success == true) {
        this.setState({isStudentUpdated: true})
				this.fetchStudentInfo();
      }
    }).catch((err)=>{
      console.error(err);
    });
  }

  render() {
    const {
      isVisible,
      show,
      proceed,
      mode,
      id,
      name,
    } = this.props;

    const {
      fetching,
      student,
      fields,
      contactFields,
    } = this.state;

    let numOfCustomData = [];
    let horizontalData = [];
    let basicInfo = [];
    let otherInfo = [];
    let otherContactInfo = [];

    if (student) {
      numOfCustomData = Object.keys(student.customData || {}).length;

      horizontalData = [
        { label: __('Age', locale), value: student.age ? __('{age} yrs old', locale, { age: student.age }) : '-' },
        { label: __('Gender', locale), value: __(GENDERS[student.gender], locale) },
        { label: __('DOB', locale), value: student.dob ? student.dob : '-' },
        { label: __('Phone', locale), value: student.phone ? student.phone : '-' },
				{ label: __('Student ID', locale), value: student.code },
        { label: __('Email', locale), value: student.email ? student.email : '-' },
        { label: __('Available Credit', locale), value: student.balance + ' ' + student.currency},
      ];

      basicInfo = [
        { label: __('Name', locale), value: student.name, },
        { label: __('Gender', locale), value: __(GENDERS[student.gender], locale) },
        { label: __('DOB', locale), value: student.dob },
        { label: __('Phone', locale), value: student.phone },
        { label: __('Email', locale), value: student.email },
        { label: __('Nickname', locale), value: student.nickName },
        { label: __('Address', locale), value: student.getAddress() },
        { label: __('Created On', locale), value: student.createdOn },
        { label: __('Remark', locale), value: student.remark },

        { label: __('Primary Guardian Name', locale), value: student.primaryGuardianName },
        { label: __('Primary Guardian Email', locale), value: student.primaryGuardianEmail },
        { label: __('Primary Guardian Phone', locale), value: student.primaryGuardianPhone },
        { label: __('Relationship', locale), value: student.primaryGuardianRelationship },

        { label: __('Secondary Guardian Name', locale), value: student.secondaryGuardianName },
        { label: __('Secondary Guardian Email', locale), value: student.secondaryGuardianEmail },
        { label: __('Secondary Guardian Phone', locale), value: student.secondaryGuardianPhone },
        { label: __('Relationship', locale), value: student.secondaryGuardianRelationship },
      ];

      fields.map((field)=>{
        const {
          label,
          id,
          type,
        } = field;

        if (student.customData) {
          let value = student.customData[id];

          if (type === 'checkbox') {
            try {
              let arrayValue = JSON.parse(value);
              value = arrayValue.toString();
            } catch (e) {

            }
          }

          if (label) {
            otherInfo.push({ label, value });
          }
        }
      });
      
      contactFields.map((field)=>{
        const {
          label,
          id,
          type,
        } = field;

        if (student.customData) {
          let value = student.customData[id];

          if (type === 'checkbox') {
            try {
              let arrayValue = JSON.parse(value);
              value = arrayValue.toString();
            } catch (e) {

            }
          }

          if (label && value) {
            otherContactInfo.push({ label, value });
          }
        }
      });
    }

    return (
      <Provider store={store}>
        <Dock
          dockStyle={{ minWidth: 760, maxWidth: 880 }}
          className='studentInfoDock'
          position='right'
          isVisible={show}
          size={0.62}
          overlayOpacity={0.2}
          onCloseDockClick={()=>{
            proceed({isUpdated: this.state.isStudentUpdated});
          }}
          useClosingTag={true}
          dockTitle={
            <StudentHeader student={student} onClickEdit={this.onClickEdit} onClickPayment={this.onClickPayment} />
          }
          useDefaultCloseButton={false}
        >
          { fetching && <Loading /> }
          { !fetching &&
            <Transition>
              <div className='basicInfo'>
                <HorizontalInfoGrid data={horizontalData} />
              </div>
              <Tabs defaultIndex={DEFAULT_TAB_INDEX} onSelect={this.onSelectTab}>
                <TabList>
                  <Tab>{__("Info", locale)}</Tab>
                  <Tab title='You do not have permission.' disabled={!userCan('read_student_class')}>
										{__("Course", locale)}
									</Tab>
                  <Tab title='You do not have permission.' disabled={!userCan('read_student_trade_record')}>
										{__("Tuition", locale)}
									</Tab>
                  <Tab title='You do not have permission.' disabled={!userCan('read_student_check_in_record')}>
										{__('Attendance', locale)}
									</Tab>
                  <Tab title='You do not have permission.' disabled={!userCan('read_student_task')}>
										{__('Planning', locale)}
									</Tab>
                </TabList>

                <TabPanel>
                  <div className='studentDetail'>
                    <h3>{__('Basic Info', locale)}</h3>
                    <VerticalInfoGrid data={basicInfo} />
                    <h3>{__('Other Info', locale)}</h3>
                    <VerticalInfoGrid data={otherInfo} />
                    {Object.keys(otherContactInfo).length > 0 &&
                    <div>
                      <h3>{__('Previous Contact Info', locale)}</h3>
                      <VerticalInfoGrid data={otherContactInfo} />
                    </div>
                    }
                  </div>
                </TabPanel>

                <TabPanel>
									<CourseRecord
										studentId={id}
										studentInfo={student}
										schoolDetail={this.props.schoolDetail.detail}
										checkStudentUpdate={(isStudentUpdated)=>{
	                    if(isStudentUpdated) {
	                      this.fetchStudentInfo();
	                    }
                    this.setState({isStudentUpdated})
                  }}/>
                </TabPanel>

                <TabPanel>
									<TuitionRecordTable studentId={id} />
                </TabPanel>

                <TabPanel>
									<Attendance state='student' studentId={id} studentName={name} />
                </TabPanel>

                <TabPanel>
									<Timeline studentInfo={student} studentId={id} />
                </TabPanel>

	            </Tabs>
	          </Transition>
					}
        </Dock>
      </Provider>
    )
  }
}

export default hotline(confirmable(DockBody), 'student', 'schoolDetail');



// WEBPACK FOOTER //
// ./src/template/Docks/StudentInfo/DockBody.js